import React from 'react';

/**
 * Form Section Component for grouping related form fields
 * 
 * @param {string} title - Section title
 * @param {React.ReactNode} children - Section content
 * @param {string} className - Additional CSS classes
 */
const FormSection = ({ title, children, className = '' }) => {
  return (
    <div className={`mb-6 ${className}`}>
      {title && (
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 pb-2 border-b border-gray-200 dark:border-gray-700">
          {title}
        </h3>
      )}
      {children}
    </div>
  );
};

export default FormSection;



